import { useAtom, useAtomValue } from 'jotai'

import { useCallback, useEffect } from 'react'
import {
  referencesProductArticleDetailShownAtom,
  referencesProductArticlesFilteredReferencesAtom,
  referencesProductSelectableColumnsAtom,
  referencesProductSelectedColumnsAtom,
} from '../services/referencesProduct.store'

export const MAX_SELECTABLES_COLUMNS = 3

export function useReferencesProduct() {
  const [selectableColumns] = useAtom(referencesProductSelectableColumnsAtom)
  const [selectedColumns, setSelectedColumns] = useAtom(referencesProductSelectedColumnsAtom)
  const referencesProductArticlesFilteredReferences = useAtomValue(
    referencesProductArticlesFilteredReferencesAtom,
  )
  const [referencesProductArticleDetailShown, setReferencesProductArticleDetailShown] = useAtom(
    referencesProductArticleDetailShownAtom,
  )

  //Close ReferencesProductRowDesktopDetailsWrapper if is not shown on the list when we update the filters
  const handleAutoCloseOnFilter = useCallback(() => {
    if (
      referencesProductArticlesFilteredReferences.length > 0 &&
      referencesProductArticleDetailShown &&
      !referencesProductArticlesFilteredReferences.includes(referencesProductArticleDetailShown)
    ) {
      setReferencesProductArticleDetailShown(null)
    }
  }, [
    referencesProductArticlesFilteredReferences,
    referencesProductArticleDetailShown,
    setReferencesProductArticleDetailShown,
  ])

  useEffect(() => {
    handleAutoCloseOnFilter()
  }, [handleAutoCloseOnFilter])

  return {
    selectedColumns,
    setSelectedColumns,
    selectableColumns,
  }
}
